import { Auth } from "@/auth/services/Auth";

export const verifyRoleMiddleware = (to, from, next) => {
    let roleNames = to.meta.role || [];

    if(!Array.isArray(roleNames)) {
        roleNames = [roleNames]
    }

    if (!to.meta.requiresAuth) {
        return next();
    }

    if (!roleNames.length) {
        return next();
    }

    if (Auth.user().hasRole(...roleNames)) {
        return next();
    }

    // FIXME: Se deben implementar los permisos 403 y sustituir por la línea de abajo que redirige a login
    return next({ name: 'login' });
}